var checkout = ( function( $ ) {

	var $container,
		switching_tabs;

	var _init = function() {
		$container = $( '#crate-checkout' );

		_setup_discount_toggle();

		_setup_tabs();
	};

	var _setup_tabs = function() {
		var $tab_links    = $container.find( '.checkout-payment-details .tabs' ),
			$tabs_content = $container.find( '.checkout-payment-details .tabs-content' );

		$tab_links.find( 'a' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( $( this ).hasClass( 'active' ) || switching_tabs ) {
				return;
			}

			switching_tabs = true;

			var $tab_content = $tabs_content.find( '.tab-content.' + $( this ).data( 'tab' ) );

			$tab_links.find( 'a' ).removeClass( 'active' );

			$tabs_content.find( '.tab-content' ).fadeOut( 400 );

			setTimeout( function(  ) {
				$tabs_content.find( '.tab-content' ).removeClass( 'active' )
			}, 410 );

			setTimeout( function() {
				$tab_content.fadeIn();
				$tab_content.addClass( 'active' );

				switching_tabs = false;
			}, 410 );

			$( this ).addClass( 'active' );
		} );

	};

	var _setup_discount_toggle = function() {
		var $discount_wrapper = $container.find( '.discount-code' );

		$discount_wrapper.find( 'a.expand-code-form' ).on( 'click', function( e ) {
			e.preventDefault();
			$discount_wrapper.toggleClass( 'open' );
			$discount_wrapper.find( '.form-wrapper' ).slideToggle();
		} );
	};

	if ( $( '#crate-checkout' ).length > 0 ) {
		_init();
	}

	return {
	}

} ) ( jQuery );

module.exports = checkout;